import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  private intermediaryUrl = environment.intermediaryUrl;
  constructor(
    private http: HttpClient,
    private httpService: HttpService,
  ) {}

  register(details: { firstName: string; lastName: string; organisation: string; mobilePhone: string; email: string }): Observable<any> {
    return this.http.post(`${this.intermediaryUrl}registration`, details, { headers: this.httpService.getHeaders() });
  }

  forgotUsername(email: string): Observable<any> {
    return this.http.post(`${this.intermediaryUrl}registration/username`, { email }, { headers: this.httpService.getHeaders() });
  }

  forgotPassword(username: string): Observable<any> {
    return this.http.post(`${this.intermediaryUrl}registration/password`, { username }, { headers: this.httpService.getHeaders() });
  }

  resetPassword(token: string, password: string): Observable<any> {
    return this.http.post(`${this.intermediaryUrl}registration/password/reset`, { token, password }, { headers: this.httpService.getHeaders() });
  }
}
